export default "__VITE_ASSET__6636afd3__"